import { render } from "./BlogCategory.vue?vue&type=template&id=986017da&scoped=true"
import script from "./BlogCategory.vue?vue&type=script&lang=js"
export * from "./BlogCategory.vue?vue&type=script&lang=js"

import "./BlogCategory.vue?vue&type=style&index=0&id=986017da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-986017da"]])

export default __exports__